import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { put } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export interface ChangeAccessSliceProps{
    memberId: number;
    userType: string;
}

export const changeMemberAccessRole = createAsyncThunk(
  "admin/update/member/role",
  async (params: ChangeAccessSliceProps, storeActions) => {
    const url = `api/v1/admin/update/role?userType=${params.userType}&memberId=${params.memberId}`;
    const response: any = await put(url, params, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.text(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const changeMemberAccessRoleSlice = createSlice({
  name: "changeMemberAccessRole",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as string | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changeMemberAccessRole.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(changeMemberAccessRole.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(changeMemberAccessRole.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = changeMemberAccessRoleSlice.actions;

export default changeMemberAccessRoleSlice;
